import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormGroup } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { RegistrationFormProvider } from '../../services/registration-form.provider';
import { RegistrationProvider } from '../../services/registration.provider';
import { CurrenciesService } from '../../services/currencies.service';
import { VcMap } from '../../util/vc-map';
import { wizardAnimation } from '../../shared/animations/route.animation';

export type RegistrationStep = 'step1' | 'step2' | 'thankyou';

const REDIRECT_DELAY_MS = 2000;

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.less'],
  animations: [wizardAnimation]
})
export class RegisterComponent implements OnInit {
  currentStep: RegistrationStep = 'step1';
  countryList: { code: string; name: string; defaultCurrency: string }[];
  timeZones: { [prop: string]: { key: string; value: string }[] };
  currencies: string[];
  registrationForm: FormGroup;
  private redirectUrl: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private currenciesService: CurrenciesService,
    private registrationFormProvider: RegistrationFormProvider,
    private registrationProvider: RegistrationProvider
  ) {
    this.registrationForm = registrationFormProvider.registrationForm;
  }

  ngOnInit(): void {
    this.prefillFromQueryParams();
    forkJoin(
      this.http.get('assets/countries.json'),
      this.http.get('assets/country2timezone.json'),
      this.currenciesService.getCurrencies()
    ).subscribe(([countries, timeZones, currencies]) => {
      this.countryList = countries as any;
      this.timeZones = timeZones as any;
      this.currencies = currencies as any;
    });
  }

  onNext(): void {
    if (this.registrationFormProvider.isStep1Valid()) {
      this.currentStep = 'step2';
    } else {
      this.registrationFormProvider.step1MarkAsTouched();
    }
  }

  onBack(): void {
    this.currentStep = 'step1';
  }

  onSubmitted(redirect: string): void {
    this.redirectUrl = redirect;
    this.currentStep = 'thankyou';
    setTimeout(() => this.redirectToStore(), REDIRECT_DELAY_MS);
  }

  private redirectToStore(): void {
    window.location.href = this.redirectUrl;
  }

  private prefillFromQueryParams(): void {
    const params = VcMap.fromRouteParamMap(this.activatedRoute.snapshot.queryParamMap);
    if (!params.hasAnyValue()) {
      return;
    }
    params.forEach((value, key) => {
      if (key === 'country') {
        this.registrationForm.get('country').setValue(value.toLowerCase());
      } else if (this.registrationForm.get(key)) {
        this.registrationForm.get(key).setValue(value);
      }
    });
    const name = params.get('extra_data[integration][name]');
    const accessToken = params.get('extra_data[integration][configuration][accessToken]');
    if (name && accessToken) {
      this.registrationProvider.mewsExtraData = {
        integration: { name, configuration: { accessToken } }
      };
    }
  }
}
